import React, { FC } from "react";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import "./HoldReasonModal.scss";
import ConfirmationModal from "../../../../common/modals/confirmationModal/ConfirmationModal";
import { HoldReason } from "../../../../documentTypes/interfaces";
import useHoldReasonModal from "../../../hooks/useHoldReasonModal";

type Props = {
  open: boolean;
  reasons: Array<HoldReason>;
  required: boolean;
  loading: boolean;
  confirmLoading: boolean;
  currentReason?: HoldReason;
  onClose: () => void;
  onConfirm: (holdReason?: HoldReason) => void;
};

const HoldReasonModal: FC<Props> = ({
  open,
  reasons,
  required,
  loading,
  confirmLoading,
  currentReason,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation("annotationSideControls");

  const { reasonId, setReasonId, options, handleClose, handleConfirm } =
    useHoldReasonModal(reasons, currentReason, onClose, onConfirm);

  return (
    <ConfirmationModal
      open={open}
      type="info"
      title={t("holdReasonModal.title")}
      confirmText={t("holdReasonModal.confirm")}
      cancelText={t("holdReasonModal.cancel")}
      confirmLoading={confirmLoading}
      confirmDisabled={required && !reasonId}
      confirmTooltip={t("holdReasonModal.requiredHint")}
      onCancel={handleClose}
      onClose={handleClose}
      onConfirm={handleConfirm}
    >
      <div className="hold-reason-modal-field">
        <label className="hold-reason-modal-field__label">
          {t("holdReasonModal.label")}
          {required ? (
            <span className="hold-reason-modal-field__required">*</span>
          ) : null}
        </label>
        <Select
          className="hold-reason-modal-field__select"
          value={reasonId}
          onChange={setReasonId}
          options={options}
          loading={loading}
          allowClear={!required}
          placeholder={t("holdReasonModal.placeholder")}
        />
      </div>
    </ConfirmationModal>
  );
};

export default HoldReasonModal;
